module.exports = __webpack_public_path__ + "static/media/eth.19dfc17e.svg";